<script lang="ts">
    import { getContext } from 'svelte';

    export let onOkay = () => {};
    export let onCancel = () => {};
    export let title = "Demande de confirmation";
    export let content = "Vous confirmez?";
    export let confirmText = "oui";
    export let cancelText = "non";
    export let showConfirm = true;

    const { close } = getContext('simple-modal');

    /**
     * cancel and close the modal
     */
    function _onCancel() {
        onCancel();
        close();
    }

    /**
     * confirm and close the modal
     */
    function _onOkay() {
        onOkay();
        close();
    }




</script>

<div id="form">
    <div id="title">
        <h2>{title}</h2>
    </div>
    <div id="description">
        <h3>{@html content}</h3>
    </div>


    <div id="submit">
      {#if showConfirm} 
        <button id="btn-ok" type="submit" on:click={_onOkay}>
            {confirmText}
        </button>
      {/if}
        <button id="btn-cancel" on:click={_onCancel}>
            {cancelText}
        </button>
    </div>
</div>

<style lang="scss">
  @import "../styles/variables";

    #form{
      margin: 40px;
      h2 {
        font-size: 26px;
        line-height: 30px;
        font-weight: bold;
      }
      h3{
        font-size: 18px;
        line-height: 28px;
        font-weight: bold;
      }

    // .product-name{
    //   color: $orange
    // }

      #submit{
        width: 100%;
        button{
          width: 100%;
          border:none;
          outline: none;
          border-radius: 100px;
          height: 40px;
          margin: 10px 0;
          cursor: pointer;
          font-weight: bold;
        }
        #btn-ok{
          background-color: $dark-black;
          color: white;
          &:disabled{
            background-color: $grey-darken;
            cursor: default;
          }
        }
        #btn-cancel{
          //display: none;
        }
      }
    }

    @media (max-width: 1024px) {
      #form{
        margin: 10px;
        #submit{
          button{
            height: 60px;
            font-size: 1.2rem;
          }
          #btn-cancel{
            display: block;
            background-color: $grey-light;
            color: $blue;
          }
        }
      }
    }

</style>
